import React from "react";
import {
    Column,
    DataGrid,
    Paging,
    Pager,
    FilterRow,
    Lookup
} from 'devextreme-react/data-grid';
import { Editing } from "devextreme-react/scheduler";
import PaginaToolbar from '../components/PaginaToolbar';
import { criarDocumentosRetencaoDs, criarPrefeituraDs } from "../DataSources";
import UserInfo from "../UserInfo";
import uiInfo from "../ui-info";

export default class DocumentosRetencaoBox extends React.Component {
    constructor() {
        super();
        this.initNewRow = this.initNewRow.bind(this);
    }

    render() {
        return (
            <div className={'content-block dx-card responsive-paddings'}>
                <PaginaToolbar titulo="Documentos de Retenção">
                    <DataGrid
                        dataSource={criarDocumentosRetencaoDs()}
                        showBorders={true}
                        rowAlternationEnabled={true}
                        remoteOperations={true}
                        focusedRowEnabled={true}
                        wordWrapEnabled={true}
                        onInitNewRow={this.initNewRow}>
                        <FilterRow visible={true} />
                        <Editing mode={"row"} allowAdding={false} allowUpdating={true} allowDeleting={true} />
                        <Column dataField={'id'} caption={"#"} width={'80'} allowEditing={false} alignment={'center'}/>
                        <Column dataField={'prefeituraId'} caption={"Prefeitura"} width={'250'} allowEditing={false}>
                            <Lookup 
                                dataSource = {criarPrefeituraDs}
                                valueExpr={"id"}
                                displayExpr={"nome"}
                            />
                        </Column>
                        <Column dataField={'descricao'} caption={"Descrição"} />
                        <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                        <Pager
                            showPageSizeSelector={true}
                            allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                        />
                    </DataGrid>
                </PaginaToolbar>
            </div>
        );
    }

    initNewRow(e) {
        e.data.prefeituraId = UserInfo.getPrefeitura();
    }

}
